import { AxiosResponse } from 'axios';
import apiInterceptor from '../utils/axios';
import { SeguimientoByEstado } from '../types/Seguimiento/SeguimientoByEstado';
import { SeguimientoDTO } from '../types/Seguimiento/SeguimientoDTO';
import { SeguimientoCreationDTO } from '../types/Seguimiento/SeguimientoCreationDTO';
import { GenericResponseData } from '../types/Response/GenericResponse';
import { GetVoidSecuencia, Secuencia } from '../types/Seguimiento/Secuencia';

const SERV_BACK: string = process.env.REACT_APP_API_ESPOL_ADS || '';
const APISEGUIMIENTO = 'api/Catalog/seguimientos/';

export default class SegumientoService {

    static async GetVisited(): Promise<SeguimientoByEstado> {
        const response1: AxiosResponse<SeguimientoByEstado> = await apiInterceptor.get(`${SERV_BACK}${APISEGUIMIENTO}`,
            {
                headers:{
                    "Content-type" : "application/json",
                },
            }
        );
        return response1.data;
    }

    static async GetById(id: number): Promise<SeguimientoDTO> {
        const response1: AxiosResponse<SeguimientoDTO> = await apiInterceptor.get(`${SERV_BACK}${APISEGUIMIENTO}${id}`,
            {
                headers:{
                    "Content-type" : "application/json",
                },
            }
        );
        return response1.data;
    }

    static async UpdateStatus(seguimientoCreation: SeguimientoCreationDTO): Promise<GenericResponseData<Secuencia>> {
        try {
            const response: AxiosResponse<Secuencia> = await apiInterceptor.post(`${SERV_BACK}${APISEGUIMIENTO}`,
                seguimientoCreation,
                {
                    headers:{
                        "Content-type" : "application/json",
                    },
                }
            );
            console.log(response);
            if (response.status === 201) {
                return {
                    status: response.status,
                    message: 'Operación completada con éxito',
                    data: response.data
                };
            } else {
                console.error('Respuesta no exitosa:', response.status);
                return {
                    status: response.status,
                    message: `Error: Código de estado ${response.status}`,
                    data: GetVoidSecuencia()
                };
            }
        } catch (error) {
            console.error('Error al realizar la solicitud:', error);
            return {
                status: 500,
                message: 'Error al realizar la solicitud',
                data: GetVoidSecuencia()
            };
        }
    }

}